var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 25,
    viewBox: "0 0 9 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info-solid",
    d: "M.937,20.714h.937V13.66H.937A.958.958,0,0,1,0,12.684V10.351a.958.958,0,0,1,.937-.977h5.25a.958.958,0,0,1,.937.977V20.714h.937A.958.958,0,0,1,9,21.691v2.333A.958.958,0,0,1,8.062,25H.937A.958.958,0,0,1,0,24.023V21.691A.958.958,0,0,1,.937,20.714ZM4.5,0A3.447,3.447,0,0,0,1.125,3.516,3.447,3.447,0,0,0,4.5,7.031,3.447,3.447,0,0,0,7.875,3.516,3.447,3.447,0,0,0,4.5,0Z",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic-info.2d570841f5c56347702b2476bd734396.svg";
export { ForwardRef as ReactComponent };